import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    btn: {
      marginTop: '30px',
      width: '50%',
    },
    container: {
      padding: '50px 40px',
    },
    formTitle: {
      color: '#172B4D',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    message: {
      color: '#999999',
      fontSize: '14px',
      lineHeight: '22px',
      marginBottom: '1rem',
      textAlign: 'center',
    },
  };
});

export default ({ title, message, btnText, btnAction }) => {
  const classes = useStyles();
  return (
    <Container maxWidth="xs" disableGutters className={classes.container}>
      <Grid container justifyContent="center">
        <Typography variant="h4" className={`page-header ${classes.formTitle}`} align="left">
          {title}
        </Typography>
        <Typography variant="body1" className={`body-copy ${classes.message}`} align="left">
          {message}
        </Typography>
        <Button variant="contained" color="primary" onClick={btnAction} className={classes.btn}>
          {btnText}
        </Button>
      </Grid>
    </Container>
  );
};
